export default __webpack_public_path__ + "static/media/user-icon.c72b5f6d.svg";